import { render, staticRenderFns } from "./AnnotationProfileProjectionTable.vue?vue&type=template&id=b4f81eea&scoped=true"
import script from "./AnnotationProfileProjectionTable.vue?vue&type=script&lang=js"
export * from "./AnnotationProfileProjectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f81eea",
  null
  
)

export default component.exports